import { getDeviceId } from '../../../../../themes/paybis/assets/js/common/nSure';

export async function addNSureHeader(config) {
  const deviceId = await getDeviceId();

  config.headers['X-Device-ID'] = deviceId;
  return config;
}
